import React from "react";
import { View, StyleSheet, FlatList } from "react-native";
import BaseController from "../../common/base/BaseController";
import NtText from "../../components/NtText";
import Logger from "../../common/utils/Logger";
import { fetchUserDevices } from "../../api/devices";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtDevider from "../../components/NtDevider";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import routes from "../../navigation/routes";
import NtDashboardItem from "../components/NtDashboardItem";
import NtNavigationBar from "../../root/components/NtNavigationBar";
import NtNavigationPannel from "../../root/components/NtNavigationPannel";
import { navigationRef } from "../../../App";
import NtLoadMoreButton from "../../components/NtLoadMoreButton";
import settings from "../../config/settings";
import { parseAccountType } from "../../common/utils/ControllerUtils";
import NtListRecordsTitle from "../../components/NtListRecordsTitle";

class DashboardController extends BaseController {
  page = 0;
  options = [
    {
      id: "all",
      icon: "view-dashboard",
      title: "All",
      action: () => {
        this.handleSetTab(this.options.find((each) => each.id == "all"));
      },
      isSelected: () => {
        return this.state.tab?.id == "all";
      },
    },
    {
      id: "residential",
      icon: "phone",
      title: "Residential",
      action: () => {
        this.handleSetTab(
          this.options.find((each) => each.id == "residential")
        );
      },
      isSelected: () => {
        return this.state.tab?.id == "residential";
      },
    },
    {
      id: "business",
      icon: "briefcase",
      title: "Business",
      action: () => {
        this.handleSetTab(this.options.find((each) => each.id == "business"));
      },
      isSelected: () => {
        return this.state.tab?.id == "business";
      },
    },
    {
      id: "wholesale",
      icon: "tag",
      title: "Wholesale",
      action: () => {
        this.handleSetTab(this.options.find((each) => each.id == "wholesale"));
      },
      isSelected: () => {
        return this.state.tab?.id == "wholesale";
      },
    },
  ];

  state = {
    ...super.state,
    data: [],
    master: [],
    totalItems: 0,
    searchText: "",
    loading: false,
    tab: this.options[0],
  };

  componentDidMount() {
    this.didFocusListener = this.props.navigation.addListener(
      "focus",
      this.handleFocus
    );

    this.handleDataFetch();
  }

  componentWillUnmount() {
    // Remove the event listener
    this.didFocusListener();
  }

  handleFocus = () => {
    Logger("On focus change");
  };

  handleDataFetch = async () => {
    Logger("Fetching Pins data");

    this.setState({ loading: true });

    if (this.page == 0) {
      const response = await fetchUserDevices(this.context.user?.user?.id);

      Logger("Data response GET: ", response);

      if (response.ok) {
        Logger("Loading for the first time.");

        let master = this.handleAccountFilter(response.data?._embedded?.voips);

        this.setState({
          master: master,
          data: master.slice(this.page, settings.pageSizeLoad),
          totalItems: response.data?.total_items,
        });
      }
    } else {
      Logger("Loading more.");

      this.setState({
        data: this.state.data.concat(
          this.state.master.slice(
            this.page * settings.pageSizeLoad,
            this.page * settings.pageSizeLoad + settings.pageSizeLoad
          )
        ),
      });
    }

    this.setState({ loading: false });
  };

  handleAccountFilter = (list) => {
    /**
     * 2 = Duo
     * 6 = Duo Canada
     * 8 = Expired
     * 25 = vDuo
     * 30 = Basic
     * 31 = VIP
     * 40 = PBX
     * 42 = Wholesale
     */

    if (this.state.tab?.id == "all") {
      return list?.filter(
        (each) =>
          parseAccountType(each._embedded?.group?.id) == "residential" ||
          parseAccountType(each._embedded?.group?.id) == "business" ||
          parseAccountType(each._embedded?.group?.id) == "wholesale"
      );
    } else if (this.state.tab?.id == "wholesale") {
      return list?.filter(
        (each) => parseAccountType(each._embedded?.group?.id) == "wholesale"
      );
    } else if (this.state.tab?.id == "residential") {
      return list?.filter(
        (each) => parseAccountType(each._embedded?.group?.id) == "residential"
      );
    } else if (this.state.tab?.id == "business") {
      return list?.filter(
        (each) => parseAccountType(each._embedded?.group?.id) == "business"
      );
    }
  };

  handleSetTab = (tab) => {
    this.state.tab = tab;
    this.setState({ tab: this.state.tab });

    this.page = 0;
    this.handleDataFetch();
  };

  renderRow = (item, index) => {
    return (
      <NtDashboardItem
        key={item.id}
        containerStyle={{ marginBottom: 10 }}
        item={item}
        onPress={() => {
          if (item._embedded?.group?.id == 42) {
            //this is a wholesale account....
            this.props.navigation.navigate(routes.wholesale, {
              // deviceid: btoa(item.id),
              deviceid: btoa(1332828),
            });
          }
        }}
      />
    );
  };

  render() {
    return (
      <View style={styles.container}>
        <NtNavigationBar />
        <View style={{ flex: 1, flexDirection: "row" }}>
          <NtNavigationPannel options={this.options} />
          <NtRootPageContainer containerStyle={{}} pageTitle={"Account List"}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginTop: 10,
              }}
            >
              <NtListRecordsTitle count={this.state.master?.length} />
            </View>

            <View style={{ marginTop: 20 }}>
              {this.state.data?.map((each, index) =>
                this.renderRow(each, index)
              )}
            </View>

            <NtLoadMoreButton
              loadingText={"Loading"}
              title="Load More Records"
              loading={this.state.loading}
              containerStyle={{ marginTop: 40, marginBottom: 40 }}
              onPress={() => {
                this.page = this.page + 1;
                this.handleDataFetch();
              }}
            />
          </NtRootPageContainer>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default DashboardController;
